import React from "react";
import EditDriverForm from "../../../forms/editdriverform";

const EditDriverMidComp=()=>{
    return(
        <EditDriverForm></EditDriverForm>
    )
}

export default EditDriverMidComp;